module.exports = __webpack_public_path__ + "img/ch7.262ebf05.jpeg";